export default "__VITE_ASSET__a6512d1a__"